import { useTwilioClient } from '@chatgenie/chat-utils';
import TwilioChatInstance from '@chatgenie/chat-utils/lib/useTwilio/twilioChatHelper';
import React, { useEffect, useState } from 'react';
import { AlertIcon, SuccessIcon } from 'src/assets/icons';
import Common from '../Common';

import styles from './style';
import useTranslation from 'src/hooks/useTranslation';

export const Alerts = ({ title, onPress }) => (
  <Common.Row style={styles.warning}>
    <Common.Row>
      <AlertIcon />
      <Common.Text weight="600" style={styles.text}>
        {title || 'Can’t connect right now'}
      </Common.Text>
    </Common.Row>
    {onPress ? (
      <Common.TouchableOpacity onPress={onPress}>
        <Common.Text weight="600" style={styles.retry}>
          Retry
        </Common.Text>
      </Common.TouchableOpacity>
    ) : null}
  </Common.Row>
);

const Success = () => {
  const { translate } = useTranslation();

  return (
    <Common.Row style={styles.success}>
      <SuccessIcon />
      <Common.Text weight="600" style={styles.text}>
        {translate('common.reconnected')}
      </Common.Text>
    </Common.Row>
  );
};

const ConnectionIndicator = () => {
  const { status } = useTwilioClient();
  const [showWarning, setShowWarning] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (status === 'denied' && !showWarning) {
      setShowWarning(true);
      setShowSuccess(false);
    }
    if (!showSuccess && showWarning && status !== 'denied') {
      setShowWarning(false);
      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
      }, 3000);
    }
    return () => {};
  }, [status, showWarning]);

  if (showSuccess) return <Success />;

  if (showWarning) return <Alerts onPress={() => TwilioChatInstance?.reconnect()} />;

  return null;
};

export default ConnectionIndicator;
